import { Capacitor } from '@capacitor/core';

export const isNativePlatform = () => Capacitor.isNativePlatform();
export const platformName = () => Capacitor.getPlatform();
export const isIOS = () => platformName() === 'ios';
export const isAndroid = () => platformName() === 'android';

export const nativeApiBaseUrl = () => {
  if (!isNativePlatform()) return '';
  const configured = String(
    process.env.REACT_APP_NATIVE_API_URL || 'https://api.pulsoraapp.com/api',
  ).trim().replace(/\/+$/, '');
  return configured;
};
